export const PaymentMethod = {
  CREDIT_CARD: 'CREDIT_CARD',
  DIRECT_DEBIT: 'DIRECT_DEBIT',
  BASED_ON_THE_INVOICE: 'BASED_ON_THE_INVOICE',
  CREDIT_FACILITY: 'CREDIT_FACILITY',
};
